import { css, jsx } from '@emotion/react'
import { VFC, Children, isValidElement, useMemo } from 'react'
import { useTextEditor } from '../../context'
import * as styles from './styles'
import { ControlButtonGroupProps } from './types'

// https://github.com/emotion-js/emotion/issues/1102#issuecomment-446887725
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const cloneElementWithCSSProp = (element: any, props: any) =>
  jsx(element.type, {
    key: element.key,
    ref: element.ref,
    ...element.props,
    ...props,
  })

export const ControlButtonGroup: VFC<ControlButtonGroupProps> = ({
  children,
  styleOverrides,
}) => {
  const { theme } = useTextEditor()
  const computedStyles = useMemo(
    () => ({
      button: css(styles.button({ theme }), styleOverrides?.button),
      group: css(styles.group({ theme }), styleOverrides?.group),
    }),
    [styleOverrides, theme]
  )

  const styledButtons = Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElementWithCSSProp(child, {
        css: css(computedStyles.button),
      })
    }

    return child
  })

  return <section css={computedStyles.group}>{styledButtons}</section>
}
